/* tslint:disable */
import React from 'react';
import { graphql } from 'gatsby';
import SEO from '../components/Common/SEO';
import WhoWeAre from '../components/About/WhoWeAre';

import OurStory from '../components/About/OurStory';

import ForbesLogo from '../icons/ForbesLogo';
import CNBCLogo from '../icons/CNBCLogo';
import NewYorkTimesLogo from '../icons/NewYorkTimesLogo';

import colors from '../styles/colors';
import styled from '@emotion/styled';
import theme from '../styles/theme';

import Grid from '../elements/Grid';

const ThreeColumn = styled(Grid)`
  align-items: baseline;
  background-color: ${colors.DarkPurple};
  color: ${colors.White};
  font-family: 'DM Sans', sans-serif;
  grid-gap: 2rem;
  padding: 3rem 4.5rem 3rem 3rem;
  
  & > * {
    grid-column-end: span 4;
  }

  ${theme.breakpoints.tabletDown} {
    padding: 6em 4em;
    grid-gap: 2rem 0;
    
    & > * {
      grid-column-end: span 12;    
    }
  }
`;

const Column = styled('div')`
  justify-self: center;
  text-align: center;

  p {
    margin-top: 0.5rem;
  }

  ${theme.breakpoints.tabletUp} {
    max-width: 20rem;
  }
`;

const About = ({ data }) => {
  // @ts-ignore
  return (
    <>
      <SEO
        title={'About Us'}
        description={`
         Our mission is to provide retirees with consistent and predictable retirement income. We’re focused
         on approaching retirement holistically, considering both health and wealth when designing a
         successful retirement.
         Kindur was created on the understanding that peace of mind and confidence in retirement comes
         from financial stability that’s specifically suited to each retiree’s goals and dreams.
        `}
      />
      <WhoWeAre />
      <ThreeColumn>
        <Column>
          <ForbesLogo />
          <p>{`"Kindur ... aims to help you create a check you can count on in retirement."`}</p>
        </Column>
        <Column>
          <CNBCLogo />
          <p>{`"New tools can help turn your retirement savings into a steady paycheck"`}</p>
        </Column>
        <Column>
          <NewYorkTimesLogo />
          <p>{`"Kindur takes your entire financial life into account and uses technology to help you pick an annuity, but also optimizes your other investments and Social Security choices."`}</p>
        </Column>
      </ThreeColumn>
      <OurStory placeholder={data.placeholderImg.childImageSharp.fluid} />
    </>
  );
};
/* tslint:enable */

export const pageQuery = graphql`
  query {
    aboutHeroImage: file(relativePath: { eq: "about/hero.png" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }
    rhianHorgan: file(relativePath: { eq: "team/rhian-horgan.png" }) {
      childImageSharp {
        fluid(maxWidth: 240) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }
    mychalCampos: file(relativePath: { eq: "team/mychal-campos.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 240) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }
    davidBlaylock: file(relativePath: { eq: "team/david-blaylock.png" }) {
      childImageSharp {
        fluid(maxWidth: 240) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }
    placeholderImg: file(relativePath: { eq: "about/about-kindur-still.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }
    americanEquity: file(relativePath: { eq: "partner/american-equity.png" }) {
      childImageSharp {
        fluid(maxWidth: 300) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }
    apexClearing: file(relativePath: { eq: "partner/apex-clearing.png" }) {
      childImageSharp {
        fluid(maxWidth: 300) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }
  }
`;

export default About;
